import { render, staticRenderFns } from "./organization-process-data-form.vue?vue&type=template&id=794f0a2a"
import script from "./organization-process-data-form.vue?vue&type=script&lang=js"
export * from "./organization-process-data-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports